
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DesignExcelDialog extends Serenity.PropertyDialog<any, any>
    {
        protected getFormKey() { return DesignExcelForm.formKey; }
        protected getIdProperty() { return DesignRow.idProperty; }
        protected getLocalTextPrefix() { return DesignRow.localTextPrefix; }
        protected getNameProperty() { return DesignRow.nameProperty; }
        protected getService() { return DesignService.baseUrl; }
        protected getInsertPermission() { return DesignRow.insertPermission; }
        protected getUpdatePermission() { return DesignRow.updatePermission; }
        protected getDeletePermission() { return DesignRow.deletePermission; }
        protected useViewMode() { return true; }
        public issues: any[];
        protected form = new DesignExcelForm(this.idPrefix);
        constructor() {
            super();

            this.form = new DesignExcelForm(this.idPrefix);
        }

        protected getDialogTitle(): string {
            return "Excel Import";
        }
        //protected getDialogButtons() {
        //    return [
        //        {
        //            text: 'Import',
        //            click: () => {
        //                if (!this.validateBeforeSave())
        //                    return;

        //                if (this.form.FileName.value == null ||
        //                    Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
        //                    Q.notifyError("Please select a file!");
        //                    return;
        //                }

        //                DesignService.ExcelImport({
        //                    FileName: this.form.FileName.value.Filename
        //                }, response => {
        //                    Q.notifyInfo(
        //                        'Inserted: ' + (response.Inserted || 0) +
        //                        ', Updated: ' + (response.Updated || 0));
        //                    this.issues = response.Issues;
        //                    if (response.ErrorList != null && response.ErrorList.length > 0) {
        //                        Q.notifyError(response.ErrorList.join(',\r\n '));
        //                    }

        //                    this.dialogClose();
        //                }, { async: false });
        //                if (this.issues.length > 0) {
        //                    Q.postToService({
        //                        service: Common.ExcelImportService.baseUrl + '/IssuesExportExcel',
        //                        request: {
        //                            Issues: this.issues,
        //                        },

        //                        target: '_blank'
        //                    });
        //                }

        //            },
        //        },
        //        {
        //            text: 'Cancel',
        //            click: () => this.dialogClose()
        //        }
        //    ];
        //}
    }
}